function getComponent() {
  return import('gsap')
    .then(({ default: gsap }) => {
      return gsap;
    })
    .catch((error) => 'An error occurred while loading gsap');
}

function getOffset(el) {
  const rect = el.getBoundingClientRect();
  return {
    ...rect,
    left: rect.left + window.scrollX,
    top: rect.top 
  };
}

function cloneHeading(selector, context) {
  const headings = document.querySelectorAll(selector);
  const heading = Array.from(headings).find(el => el.offsetParent !== null);
  const headingClone = heading.cloneNode(true);
  headingClone.classList.add('FrontCover-heading--clone')

  function setSize() {
    const { left, top, width } = heading.getBoundingClientRect();
    const contextRect = context.getBoundingClientRect();
    headingClone.style.left = `${left - contextRect.left}px`;
    headingClone.style.top = `${top - contextRect.top}px`;
    headingClone.style.width = `${width}px`;
  }

  window.addEventListener('resize', setSize);

  setSize();

  return headingClone;
}

async function init() {
  const container = document.querySelector('.js-HeroImage');

  if(!container) return;

  const gsap = await getComponent();
  const speed = 0.35;
  const mouse = { x: 0, y: 0 };
  const mq = window.matchMedia('(min-width: 1024px)');
  const maskEl = document.querySelector('.js-HeroImage-mask');
  const items = gsap.utils.toArray(".js-HeroImage-bubble").map(element => {
    return {
      element,
      shiftValue: element.getAttribute("data-value") / 250,
      xSet: gsap.quickTo(element, "x", { 
        duration: 0.6, 
        ease: "power3"
      }),
      ySet: gsap.quickTo(element, "y", { 
        duration: 0.6, 
        ease: "power3"
      })
    }
  });
  const mask = {
    element: maskEl,
    shiftValue: maskEl.getAttribute("data-value") / 250,
    xSet: gsap.quickTo(maskEl, "--clip-x", { 
      duration: 2, 
      ease: "power3",
      overwrite: true
    }),
    ySet: gsap.quickTo(maskEl, "--clip-y", { 
      duration: 2, 
      ease: "power3",
      overwrite: true
    }),
    xOrig: mq.matches ? maskEl.clientWidth * 0.75 : maskEl.clientWidth * 0.5,
    yOrig: maskEl.clientHeight / 2,
    width: maskEl.clientWidth,
    height: maskEl.clientHeight
  };

  const headingClone = cloneHeading('.js-HeroImageHeading', mask.element);
  mask.element.appendChild(headingClone);

  gsap.set(mask.element, {
    "--clip-x": `${mask.xOrig}px`,
    "--clip-y": `${mask.yOrig}px`
  });

  function getSpotlightSize() {
    const percent = getComputedStyle(mask.element).getPropertyValue('--clip-percentage');
    const size = parseFloat(percent) / 100.0;
    return ((Math.sqrt(Math.pow(mask.width, 2) + Math.pow(mask.height, 2)) / Math.sqrt(2))) * size;
  }

  function moveMask() {
    const spotlightSize = getSpotlightSize();
    const maskMinX = (mq.matches ? (mask.width / 2) : 0) + spotlightSize;
    const maskMinY = 0 + spotlightSize;
    const maskMaxX = mask.width - spotlightSize;
    const maskMaxY = mask.height - spotlightSize;
    const duration = gsap.utils.random(3, 5);

    mask.tween = gsap.to(mask.element, {
      "--clip-x": `${gsap.utils.random(maskMinX, maskMaxX)}px`,
      "--clip-y": `${gsap.utils.random(maskMinY, maskMaxY)}px`,
      ease: "power1.inOut",
      duration,
      onComplete: moveMask
    })
  }  

  function moveBubbles() {
    items.forEach(item => {
      function move() {
        const duration = gsap.utils.random(3, 5);
        const distance = item.element.clientWidth / 4;

        item.tween = gsap.to(item.element, {
          x: `random(-${distance}, ${distance}, 1)`, 
          y: `random(-${distance}, ${distance}, 1)`,
          ease: "power1.inOut",
          duration,
          onComplete: move
        });
      }
    
      move();
    });
  }  

  function moveRelativeToPointer() {
    const { left, top, width, height } = container.getBoundingClientRect();
    const halfW = width / 2;
    const halfH = height / 2;  
    const mouseX = mouse.x - left;
    const mouseY = mouse.y - top;
    const circleSize = getSpotlightSize();
    let x = gsap.utils.interpolate(-halfW, halfW, mouseX / width);
    let y = gsap.utils.interpolate(-halfH, halfH, mouseY / height);

    if(mouseX < circleSize) {
      x = x + (circleSize - mouseX);
    }

    if(mouseX > (mask.width - circleSize)) {
      x = x + ((mask.width - circleSize) - mouseX);
    }

    if(mouseY < circleSize) {
      y = y + (circleSize - mouseY);
    }
    
    if(mouseY >= (mask.height - circleSize)) {
      y = y + ((mask.height - circleSize) - mouseY);
    }

    mask.xSet(x + (mask.width / 2));
    mask.ySet(y + (mask.height / 2));

    items.forEach(item => {
      let dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio(60));
      let x = gsap.getProperty(item.element, 'x');
      let y = gsap.getProperty(item.element, 'y');

      x += ( (item.shiftValue * mouse.x) - x ) * dt;
      y += ( (item.shiftValue * mouse.y) - y ) * dt;

      item.xSet(x);
      item.ySet(y);
    });
  }

  container.addEventListener("mousemove", e => {    
    mouse.x = e.x;
    mouse.y = e.y;  
  });

  container.addEventListener("mouseover", e => {    
    items.forEach(item => {
      if(item.tweenReturn) {
        item.tweenReturn.kill();
      }

      item.tween.pause();
      item.xSet.tween.invalidate();
      item.ySet.tween.invalidate();
    });

    if(mask.tweenReturn) {
      mask.tweenReturn.kill();
    }

    mask.tween.pause();
    mask.xSet.tween.invalidate();
    mask.ySet.tween.invalidate();
    
    gsap.ticker.add(moveRelativeToPointer);
  });

  container.addEventListener("mouseleave", e => {    
    gsap.ticker.remove(moveRelativeToPointer);

    items.forEach(item => {
      item.tweenReturn = gsap.to(item.element, {
        x: 0, 
        y: 0,
        ease: "power1.inOut",
        duration: 1,
        repeat: 0,
        overwrite: true,
        onComplete: () => {
          item.tween.invalidate();
          item.tween.restart();
        }
      }); 
    });

    mask.tweenReturn = gsap.to(mask.element, {
      "--clip-x": `${mask.xOrig}px`,
      "--clip-y": `${mask.yOrig}px`,
      ease: "power1.inOut",
      duration: 1,
      repeat: 0,
      overwrite: true,
      onComplete: () => {
        mask.tween.invalidate();
        mask.tween.restart();
      }
    }); 
  });

  window.addEventListener('resize', () => {
    mask.width = mask.element.clientWidth;
    mask.height = mask.element.clientHeight;
    mask.xOrig = mq.matches ? mask.element.clientWidth * 0.75 : mask.element.clientWidth * 0.5;
    mask.yOrig = mask.element.clientHeight / 2;

    gsap.set(mask.element, {
      "--clip-x": `${mask.xOrig}px`,
      "--clip-y": `${mask.yOrig}px`,
      overwrite: true,
      onComplete: () => {
        mask.tween.invalidate();
        mask.tween.restart();
      }
    });
  })

  moveMask();
  moveBubbles();
}

document.addEventListener('DOMContentLoaded', () => {
  init();
})